const SAFE_URL_PROTOCOLS = ['http:', 'https:'];

/**
 * Valida que una URL use un esquema seguro (http/https) antes de usarla en
 * `window.open` / `window.location.href`. Bloquea esquemas como `javascript:`
 * o `data:` que permitirían XSS si la URL proviene de datos no confiables.
 */
export function hasSafeProtocol(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return SAFE_URL_PROTOCOLS.includes(parsed.protocol);
  } catch {
    return false;
  }
}

/**
 * Abre una URL externa en una pestaña nueva sin exponer `window.opener`,
 * dejando intacta la pantalla actual (no se pierde el estado del formulario).
 * Ignora URLs con esquemas no seguros.
 */
export function openExternalUrl(url: string): void {
  if (!hasSafeProtocol(url)) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}
